import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import findIndex from 'lodash/findIndex';
import { STREAM__SET_PARAM, STREAM__FETCH_FAILURE, STREAM__DELETE_ITEMS, STREAM__REPLACE_ITEM, STREAM__MOVE_ITEM, STREAM__INSERT_ITEMS, replaceItems, markAsFetching, markAsCancelled } from './actions';
export const handleInitAction = (streamState, action)=>{
    var _fetchNextCallback, _fetchPreviousCallback, _fetchAllCallback;
    const { streamId, streamParams = {}, streamType, groupId, itemsPerFetch, items = [], total, hasMore = false, hasLess = false, fetchNextCallback, fetchPreviousCallback, fetchAllCallback } = action;
    return _object_spread_props(_object_spread({}, streamState), {
        streamId,
        streamParams,
        streamType,
        groupId,
        itemsPerFetch,
        items,
        total,
        hasMore,
        hasLess,
        // store only the action type as the callback itself doesn't serialize after ssr
        // since the signature is fixed, we can easily re-create the action creators anyway
        fetchNextCallback: (_fetchNextCallback = fetchNextCallback) === null || _fetchNextCallback === void 0 ? void 0 : _fetchNextCallback.toString(),
        fetchPreviousCallback: (_fetchPreviousCallback = fetchPreviousCallback) === null || _fetchPreviousCallback === void 0 ? void 0 : _fetchPreviousCallback.toString(),
        fetchAllCallback: (_fetchAllCallback = fetchAllCallback) === null || _fetchAllCallback === void 0 ? void 0 : _fetchAllCallback.toString()
    });
};
export const handleFetchAction = (streamState)=>_object_spread_props(_object_spread({}, streamState), {
        isFetching: true
    });
export const handleFetchSuccessAction = (streamState, action)=>_object_spread_props(_object_spread({}, streamState), {
        isFetching: false,
        items: [
            ...streamState.items || [],
            ...action.items || []
        ],
        total: action.total !== undefined ? action.total : streamState.total,
        hasMore: action.hasMore,
        errorMsg: undefined,
        fetchFailuresConsecutive: 0
    });
export const handleFetchPreviousSuccessAction = (streamState, { payload: { items, dedupeFunction = ()=>true, hasLess } })=>{
    const dedupedItems = items.filter((item)=>dedupeFunction(item, streamState.items));
    if (!dedupedItems.length) {
        return _object_spread_props(_object_spread({}, streamState), {
            fetchFailuresConsecutive: 0
        });
    }
    return _object_spread_props(_object_spread({}, streamState), {
        isFetching: false,
        fetchFailuresConsecutive: 0,
        items: [
            ...dedupedItems,
            ...streamState.items
        ],
        hasLess
    });
};
export const handleFetchAllSuccessAction = (streamState, { payload: { items } })=>{
    return _object_spread_props(_object_spread({}, streamState), {
        isFetching: false,
        fetchFailuresConsecutive: 0,
        items,
        hasLess: false,
        hasMore: false
    });
};
export const handleFetchFailureAction = (streamState, action)=>_object_spread_props(_object_spread({}, streamState), {
        isFetching: false,
        errorMsg: action.errorMsg,
        fetchFailuresConsecutive: (streamState.fetchFailuresConsecutive || 0) + 1
    });
export const handleDeleteItemsAction = (streamState, action)=>{
    var _streamState_items;
    const items = (_streamState_items = streamState.items) !== null && _streamState_items !== void 0 ? _streamState_items : [];
    var _action_isEqual;
    const isEqual = (_action_isEqual = action.isEqual) !== null && _action_isEqual !== void 0 ? _action_isEqual : (a, b)=>a === b;
    const updatedItems = items.filter((item)=>!action.items.some((i)=>isEqual(item, i)));
    const removedCount = items.length - updatedItems.length;
    const updatedTotal = (streamState.total || 0) - removedCount;
    return _object_spread_props(_object_spread({}, streamState), {
        items: updatedItems,
        total: updatedTotal > 0 ? updatedTotal : 0
    });
};
export const handleMoveItemAction = (streamState, action)=>{
    const { items } = streamState;
    const { position, item } = action;
    const itemPosition = items.indexOf(item);
    if (itemPosition === position) {
        return streamState;
    }
    const updatedItems = [
        ...items
    ];
    updatedItems.splice(itemPosition, 1);
    updatedItems.splice(position, 0, item);
    return _object_spread_props(_object_spread({}, streamState), {
        items: updatedItems
    });
};
export const handleReplaceItemAction = (streamState, action)=>{
    const itemIndex = findIndex(streamState.items || [], action.predicate);
    if (itemIndex === -1) {
        return streamState;
    }
    const newItems = [
        ...streamState.items
    ];
    newItems[itemIndex] = action.newItem;
    return _object_spread_props(_object_spread({}, streamState), {
        items: newItems
    });
};
export const handleInsertItemsAction = (streamState, action)=>{
    const sorted = action.newItems.slice();
    sorted.sort((a, b)=>{
        if (a.offset === b.offset) {
            return 0;
        }
        return a.offset > b.offset ? 1 : -1;
    });
    const newItems = [
        ...streamState.items
    ];
    let inserted = 0;
    for (const elem of sorted){
        if (action.deduplicate && newItems.includes(elem.item)) {
            continue;
        }
        inserted++;
        const offset = Math.max(elem.offset, 0);
        if (offset >= newItems.length) {
            newItems.push(elem.item);
        } else {
            newItems.splice(offset, 0, elem.item);
        }
    }
    return _object_spread_props(_object_spread({}, streamState), {
        total: (streamState.total || 0) + inserted,
        items: newItems
    });
};
export const handleSetParam = (streamState, action)=>_object_spread_props(_object_spread({}, streamState), {
        streamParams: _object_spread_props(_object_spread({}, streamState.streamParams), {
            [action.paramType]: action.paramValue
        })
    });
export const handleReplaceItems = (streamState, { payload: { updatedItems } })=>_object_spread_props(_object_spread({}, streamState), {
        items: updatedItems
    });
export const handleMarkAsFetching = (streamState, action)=>_object_spread_props(_object_spread({}, streamState), {
        isFetching: true
    });
export const handleMarkAsCancelled = (streamState, action)=>_object_spread_props(_object_spread({}, streamState), {
        isFetching: false
    });
export const handleEmptyStream = (streamState, action)=>_object_spread_props(_object_spread({}, streamState), {
        isFetching: false,
        items: [],
        total: 0,
        hasMore: false,
        hasLess: false,
        fetchFailuresConsecutive: 0
    });
export const handleResetStream = (streamState, action)=>_object_spread_props(_object_spread({}, streamState), {
        isFetching: false,
        items: [],
        hasMore: true,
        hasLess: false,
        fetchFailuresConsecutive: 0
    });
// installed to reducer of every stream type as they are
export const commonActionHandlers = {
    [STREAM__FETCH_FAILURE]: (streamState, action)=>handleFetchFailureAction(streamState, action),
    [STREAM__MOVE_ITEM]: (streamState, action)=>handleMoveItemAction(streamState, action),
    [STREAM__DELETE_ITEMS]: (streamState, action)=>handleDeleteItemsAction(streamState, action),
    [STREAM__REPLACE_ITEM]: (streamState, action)=>handleReplaceItemAction(streamState, action),
    [STREAM__SET_PARAM]: (streamState, action)=>handleSetParam(streamState, action),
    [STREAM__INSERT_ITEMS]: (streamState, action)=>handleInsertItemsAction(streamState, action),
    [replaceItems.toString()]: handleReplaceItems,
    [markAsFetching.toString()]: handleMarkAsFetching,
    [markAsCancelled.toString()]: handleMarkAsCancelled
};
